import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from 'pages/Fields/fields.constants';

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: ${em(8)};
  margin-bottom: ${em(14)};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(12)};
`;

export const Name = styled.h1`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${rem(22)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const FieldChip = styled.button`
  padding: ${em(3)} ${em(10)};
  font-size: ${rem(14)};
  color: ${PALETTE.brandDark};
  background: ${PALETTE.brandTint};
  border: ${em(1)} solid ${PALETTE.brandBorder};
  border-radius: ${em(14)};
  cursor: pointer;
`;

export const Stats = styled.div`
  display: flex;
  gap: ${em(32)};
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(2)};
`;

export const Value = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.fonts.mono};
    font-size: ${rem(22)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const Label = styled.span`
  ${({ theme }) => css`
    font-size: ${rem(14)};
    color: ${theme.colors.nature.n3};
  `}
`;

export const Track = styled.div`
  ${({ theme }) => css`
    height: ${em(4)};
    max-width: ${em(420)};
    background: ${theme.colors.nature.n2};
    border-radius: ${em(2)};
    overflow: hidden;
  `}
`;

export const Fill = styled.div`
  height: 100%;
  width: ${({ $size }) => $size}%;
  background: ${PALETTE.brand};
`;

export const Note = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${rem(14)};
    color: ${theme.colors.nature.n3};
  `}
`;
